import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AbstractStateInterface } from '../../interface/abstract';
import { OnThisDayInterface } from '../../interface/onthisday';
import { InterfaceToSearchParams } from '../../utils/helper';
import { ApiService } from '../../utils/apiService';

type DataState = AbstractStateInterface<OnThisDayInterface>;

export interface OnThisDaySearch {
  id?: string;
}
const initialState: DataState = {
  data: [],
  detail: null,
  loading: false,
};

export const findOnThisDayByCondition = createAsyncThunk(
  'admin-api/on-this-day/get',
  async (payload: OnThisDaySearch, thunkAPI) => {
    const searchParams = InterfaceToSearchParams(payload);
    try {
      const response = await ApiService(`admin-api/on-this-day?${searchParams}`, 'GET', null);
      if (response.statusCode !== 200) {
        return thunkAPI.rejectWithValue({
          code: response.statusCode,
          error: response.error || 'Login failed',
        });
      }
      return {
        code: response.statusCode,
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        code: error.response?.status || 500,
        error: error.message || 'Error',
      });
    }
  },
);
export const getAllOnThisDays = createAsyncThunk('admin-api/on-this-day/all', async (_, thunkAPI) => {
  try {
    const response = await ApiService(`admin-api/on-this-day/all`, 'GET', null);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});

export const createOnThisDay = createAsyncThunk('admin-api/on-this-day', async (payload: FormData, thunkAPI) => {
  try {
    const response = await ApiService(`admin-api/on-this-day`, 'POST', payload);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});

export const updateOnThisDay = createAsyncThunk('admin-api/on-this-day/put', async (payload: FormData, thunkAPI) => {
  try {
    const response = await ApiService(`admin-api/on-this-day`, 'PUT', payload);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});

export const deleteOnThisDay = createAsyncThunk(
  'admin-api/on-this-day/delete',
  async (payload: OnThisDaySearch, thunkAPI) => {
    const searchParams = InterfaceToSearchParams(payload);
    try {
      const response = await ApiService(`admin-api/on-this-day?${searchParams}`, 'DELETE', null);
      if (response.statusCode !== 200) {
        return thunkAPI.rejectWithValue({
          code: response.statusCode,
          error: response.error || 'Login failed',
        });
      }
      return {
        code: response.statusCode,
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        code: error.response?.status || 500,
        error: error.message || 'Error',
      });
    }
  },
);

const onThisDaySlice = createSlice({
  name: 'on-this-day',
  initialState,
  reducers: {
    resetOnThisDaySlice: () => {
      return { ...initialState };
    },
    resetDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOnThisDays.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOnThisDays.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload.data)) {
          state.data = action.payload.data as OnThisDayInterface[];
        } else {
          state.data = [];
        }
      })
      .addCase(getAllOnThisDays.rejected, (state) => {
        state.loading = false;
      })
      .addCase(findOnThisDayByCondition.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload.data)) {
          state.detail = action.payload.data[0] as OnThisDayInterface;
        } else {
          state.detail = null;
        }
      })
      .addCase(findOnThisDayByCondition.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { resetOnThisDaySlice, resetDetail } = onThisDaySlice.actions;
export default onThisDaySlice.reducer;
